import React, {Component} from 'react';
import {Row, Col} from "react-bootstrap";
import TrasyService from "../../../trasyConfig/trasy/TrasyService";
import TopIf from "../../../../../componentsTopsa/if/TopIf";
import {TopAlertInformacja, TopAlertOstrzezenie, TopAlertUwaga} from "../../../../../componentsTopsa/alerty/TopAlerts";
import {TopButtonAction} from "../../../../../componentsTopsa/buttons/TopButtons";
import RozkladService from "../RozkladService";
import ReactNotify from 'react-notify';
import KonfiguracjaService from "../../../../administracja/konfiguracja/KonfiguracjaService";

export default class GenerujRozkladContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            trasy: [],
            data_start: '',
            data_koniec: '',
            pokazGeneruj: false,
            trwaGenerowanie: false,
            responseinfo: [],
            czy_data_ok:true,
        };
        this.getTrasy = this.getTrasy.bind(this)
        this.onClickGeneruj = this.onClickGeneruj.bind(this)
    }

    componentDidMount() {
        this.getTrasy();
        this.pobierzOkres();
    }

    pobierzOkres() {

        KonfiguracjaService.pobierzWartoscStartRozkladu().then(function (responseStart) {
            KonfiguracjaService.pobierzWartoscKoniecRozkladu().then(function (responseKoniec) {
                let start = responseStart.data;
                let koniec = responseKoniec.data;


                this.setState({
                    data_start: start,
                    data_koniec: koniec,
                    czy_data_ok: (start > new Date().toJSON().substring(0,10))
                })
            }.bind(this))
        }.bind(this))

    }

    getTrasy() {
        TrasyService.getTrasy().then(function (response) {
            this.setState({trasy: response.data.content})
        }.bind(this))
    }

    onClickGeneruj() {

        this.setState({
            trwaGenerowanie: true,
            responseinfo: []
        })

        RozkladService.getZrobRozkladDlaWszystkichTras().then(function (response) {

            console.log(response)

            console.log(response.data)

            let odpowiedzok = true;


            if (Boolean(response)) {

                if (response.status < 300) {

                    if (response.data) {
                        if (response.data.length > 0) {
                            if (Boolean(response.data.find(i => i.info.indexOf("Nie można zrobic rozkładu") > -1))) {
                                odpowiedzok = false
                            }
                        }
                    }

                }
                else {
                    odpowiedzok = false;
                }

                if (odpowiedzok) {
                    this.refs.notificator.success('Pomyślnie wygenerowano rozkład jazdy', "", 3000)
                }
                else {
                    this.refs.notificator.error('Wystąpił błąd podczas generowania', "", 3000)
                }


                if (response.data) {
                    if (response.data.length > 0) {

                        this.setState({responseinfo: response.data})
                    }
                }

            }
            this.setState({trwaGenerowanie: false})
        }.bind(this))
    }

    render() {

        return (
            <div>
                <TopIf isTrue={this.state.trwaGenerowanie}>
                    <div id={'GenerowanieContainer'}>
                        <h1>
                            <i className={'fa fa-spinner fa-spin'}></i>
                            <div>
                                Trwa generowanie rozkładu...
                            </div>
                            <h6>
                                Proces ten może potrwać dłuższą chwilę
                            </h6>
                        </h1>
                    </div>
                </TopIf>
                <ReactNotify ref='notificator'/>
                <Row>
                    <Col xs={6}>
                        <Row>
                        <Col xs={12}>
                            <TopAlertInformacja
                                text={'Przycisk Generuj spowoduje wygenerowanie rozkładu jazdy dla poniższych tras w okresie ' + this.state.data_start + ' - ' + this.state.data_koniec + '. Czy chcesz wygenerować rozkład?'}/>
                        </Col>
                        <Col xs={12}>
                            <ul>
                                {
                                    this.state.trasy.map(t => {
                                        if (t.status > -1)
                                            return <li>{t.nazTr}</li>
                                    })
                                }
                            </ul>
                        </Col>
                        <Col xs={12}>
                            <TopIf isTrue={!Boolean(this.state.pokazGeneruj)}>
                                <TopButtonAction text={'Pokaż przycisk "Generuj"'} iconType={'fa fa-eye'} btnSize={'medium'} onClick={() => {
                                    this.setState({pokazGeneruj: true})
                                }} btnDisabled={!this.state.czy_data_ok}/>
                            </TopIf>
                            <TopIf isTrue={Boolean(this.state.pokazGeneruj)}>
                                <TopButtonAction text={'Generuj rozkład jazdy'} iconType={'fa fa-table'} btnSize={'medium'} btnColor={'warning'}
                                                 onClick={this.onClickGeneruj}/>
                            </TopIf>
                        </Col>
                            <TopIf isTrue={!this.state.czy_data_ok}>
                            <Col xs={12}>
                                <TopAlertUwaga text={"Nie można wygenerować rozkładu ponieważ data rozpoczęcia nie może być wcześniejsza od daty dzisiejszej. Proszę zmienić datę rozpoczęcia w Administracja/Konfiguracja bądź wygenerować rozkład ręcznie."}/>
                            </Col>
                            </TopIf>
                    </Row>
                    </Col>
                    <Col xs={6}>
                        <Row>
                        <Col xs={12}>
                            {
                                this.state.responseinfo.length > 0 ?
                                    <TopAlertOstrzezenie text={"Pojawiły się następujące komplikacje podczas próby wygenerowania rozkładu:"}/> : ""
                            }
                            <ul>
                                {
                                    this.state.responseinfo.map(item => {
                                        return <li>{item.info}</li>
                                    })
                                }
                            </ul>
                        </Col>
                    </Row>
                    </Col>
                </Row>


            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/konfiguracja/rozkladConfig/rozklad/generujRozklad/GenerujRozkladContainer.js